export default __webpack_public_path__ + "static/media/bullet-no-text.c321f1b2.png";